import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Message from './message';
import './index.css';

export default class Alert extends Component {
  state = {
    messages: [],
    type: '',
    intervalList: [],
    unclosed: this.props.unclosed,
  };

  componentDidMount() {
    const { messages, show, type } = this.props;
    if (messages) this.setState({ messages, type });
    if (show) this.show(type, messages);
  }

  show(type, messages, hide = true) {
    this.state.intervalList.forEach((x) => clearInterval(x));

    if (hide) {
      this.setState({ intervalList: [] }, () => {
        if (!this.state.messages.length) {
          this.setState({ type, messages });

          this.state.intervalList.push(
            setTimeout(() => {
              if (this.self) this.self.classList.add('alert-hidden');
            }, this.props.interval * 650),
          );

          this.state.intervalList.push(
            setTimeout(() => {
              this.setState({ type: '', messages: [] });
              if (this.self) this.self.classList.remove('alert-hidden');
            }, this.props.interval * 1000),
          );
        }
      });
    } else {
      this.setState({ type, messages, unclosed: true });
    }
  }

  close() {
    this.setState({ type: '', messages: [] });
  }

  render() {
    const { messages } = this.state;
    const display = { display: messages.length > 0 ? 'block' : 'none' };
    const onClick = this.state.unclosed ? () => {} : this.close.bind(this);
    const style = {
      ...this.props.style,
      ...display,
    };

    return (
      <div className={`alert-wrapper ${this.state.type}`} onClick={onClick} style={display}>
        <div style={style} ref={(ref) => (this.self = ref)} className={`alert ${this.state.type}`}>
          {messages.map((m) => (
            <Message key={m} message={m} type={this.state.type} />
          ))}
        </div>
      </div>
    );
  }
}

Alert.propTypes = {
  interval: PropTypes.number,
  unclosed: PropTypes.bool,
};

Alert.defaultProps = {
  interval: 3,
  unclosed: false,
};
